import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Descriptions, Tag, Space, App, Typography, Row, Col } from 'antd';
import { EyeOutlined, EditOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { getMembershipTypeById } from '../../services/memberships';

const { useApp } = App;

const MembershipTypeViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { message } = useApp();
  const { Title } = Typography;
  const [loading, setLoading] = useState(true);
  const [membershipType, setMembershipType] = useState(null);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    getMembershipTypeById(id)
      .then((response) => {
        setMembershipType(response.data);
      })
      .catch(() => {
        message.error('No se pudo cargar el tipo de membresía');
        navigate('/memberships/all');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, navigate, message]);

  if (!membershipType && !loading) {
    return (
      <div style={{ padding: 24 }}>
        <Card>
          <p>No se encontró el tipo de membresía.</p>
          <Button onClick={() => navigate('/memberships/all')}>
            Volver a la lista
          </Button>
        </Card>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('es-MX');
  };

  return (
    <div style={{ padding: 24, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button 
            type="text" 
            icon={<ArrowLeftOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
            onClick={() => navigate('/memberships/all')}
            style={{ 
              padding: 0,
              color: '#262626',
              fontSize: '24px',
              fontWeight: '100',
              height: 'auto'
            }}
          />
            <Title level={3} style={{ marginBottom: 0 }}>Detalles del Tipo de Membresía</Title>
        </div>

        <Button 
          type="text" 
          icon={<EditOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
          onClick={() => navigate(`/memberships/${id}/edit`)}
          style={{ 
            padding: 0,
            color: '#262626',
            fontSize: '24px',
            fontWeight: '100',
            height: 'auto'
          }}
        />
      </div>

      <Card
        style={{
          borderRadius: '32px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >


      <Row gutter={16}>
          <Col xs={24} md={24}>
            <Row gutter={16}>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Nombre
                </div>
                <div className="field-value">
                  {membershipType?.name || 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={24} className='col-spaced'>
                <div className="field-label">
                  Descripcion
                </div>
                <div className="field-value">
                  {membershipType?.description || 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Precio
                </div>
                <div className="field-value">
                    ${membershipType?.price?.toFixed(2) || '0.00'}
                </div>
              </Col>

              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Duracion
                </div>
                <div className="field-value">
                    {membershipType?.durationDays} días
                </div>
              </Col>

              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Estado
                </div>
                <div className="field-value">
                {membershipType?.deletedAt ? (
                    <Tag color="red">Eliminado</Tag>
                ) : (
                    <Tag color={membershipType?.isActive ? 'green' : 'volcano'}>
                    {membershipType?.isActive ? 'Activo' : 'Inactivo'}
                    </Tag>
                )}
                </div>
              </Col>



            </Row> 
          </Col>
        </Row> 


      </Card>
    </div>
  );
};

export default MembershipTypeViewPage;